<template>
  <div class="video-card video-card-list">
    <div class="video-card-image">
      <a
        class="play-icon"
        href="#"
      >
        <i class="fas fa-play-circle" />
      </a>
      <a href="#">
        <img
          class="img-fluid"
          :src="require(`@/assets/theme/img/v${Math.floor(Math.random()*8) + 1}.png`)"
          alt=""
        >
      </a>
      <div class="time">
        3:50
      </div>
    </div>
    <div class="video-card-body">
      <div class="btn-group float-right right-action">
        <a
          href="#"
          class="right-action-link text-gray"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i
            class="fa fa-ellipsis-v"
            aria-hidden="true"
          />
        </a>
        <div class="dropdown-menu dropdown-menu-right">
          <a
            class="dropdown-item"
            href="#"
          >
            <i class="fas fa-fw fa-star" /> &nbsp;
            Top Rated
          </a>
          <a
            class="dropdown-item"
            href="#"
          >
            <i class="fas fa-fw fa-signal" />
            &nbsp; Viewed
          </a>
          <a
            class="dropdown-item"
            href="#"
          >
            <i class="fas fa-fw fa-times-circle" />
            &nbsp; Close
          </a>
        </div>
      </div>
      <div class="video-title">
        <a href="#">
          Here are many variati of passages of Lorem
        </a>
      </div>
      <div class="video-page text-success">
        Education <a
          title=""
          data-placement="top"
          data-toggle="tooltip"
          href="#"
          data-original-title="Verified"
        >
          <i class="fas fa-check-circle text-success" />
        </a>
      </div>
      <div class="video-view">
        1.8M views &nbsp;<i class="fas fa-calendar-alt" /> 11 Months ago
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
